import React, { useRef } from 'react';
import { message } from 'antd';
import {
  CameraOutlined,
  FileTextOutlined,
  PictureOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  ThunderboltOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { PLUS_PANEL_ITEMS } from '../PlusPanelConfig';
import { messageModel } from '../MessageModel';
import { AliOssUtil } from '../../utils/AliOssUtil';
import { OssScene } from '../../global/OssConfig';

const ICONS: Record<string, React.ReactNode> = {
  image: <PictureOutlined />,
  video: <VideoCameraOutlined />,
  camera: <CameraOutlined />,
  quickContract: <ThunderboltOutlined />,
  order: <FileTextOutlined />,
  product: <ShoppingCartOutlined />,
};

interface MessageInputToolbarExtrasProps {
  roomId: number;
}

/** 原加号面板能力，平铺在输入框工具栏 */
export const MessageInputToolbarExtras: React.FC<MessageInputToolbarExtrasProps> =
  observer(({ roomId }) => {
    const imageInputRef = useRef<HTMLInputElement>(null);
    const videoInputRef = useRef<HTMLInputElement>(null);

    const showAppTip = () => {
      message.info('暂不支持，请前往 APP 发送');
    };

    const uploadAndSend = async (file: File, isVideo: boolean) => {
      try {
        const url = await AliOssUtil.uploadFile(file, OssScene.chat);
        const content = JSON.stringify({
          type: 'image',
          url,
          width: isVideo ? 280 : 160,
          height: isVideo ? 200 : 160,
        });
        await messageModel.sendImageCard(roomId, content);
      } catch {
        message.error('发送失败');
      }
    };

    const onItemClick = (key: string, supported: boolean) => {
      messageModel.closeEmojiPanel();
      if (!supported) {
        showAppTip();
        return;
      }
      if (key === 'image') {
        imageInputRef.current?.click();
      } else if (key === 'video') {
        videoInputRef.current?.click();
      }
    };

    return (
      <>
        <input
          ref={imageInputRef}
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = '';
            if (file) {
              void uploadAndSend(file, false);
            }
          }}
        />
        <input
          ref={videoInputRef}
          type="file"
          accept="video/*"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = '';
            if (file) {
              void uploadAndSend(file, true);
            }
          }}
        />
        {PLUS_PANEL_ITEMS.sort((a, b) => a.order - b.order).map((item) => (
          <button
            key={item.key}
            type="button"
            className="message-input-tool-btn"
            title={item.label}
            onClick={() => onItemClick(item.key, item.supportedOnWeb)}
          >
            {ICONS[item.key] || <ShoppingOutlined />}
          </button>
        ))}
      </>
    );
  });
